export default '4.5.0';


// WEBPACK FOOTER //
// ../node_modules/instantsearch.js/es/lib/version.js